export default __webpack_public_path__ + "static/media/youtube.f43659c0.svg";